module.exports = __webpack_public_path__ + "static/media/logan_yates.e478160d.jpg";